import { dequal } from 'dequal';

export const deepEqual = (foo: any, bar: any) => {
  return dequal(foo, bar);
};
